import { http } from './config';

export default {

    // ─── CATEGORÍAS ─────────────────────────────────────────────
    listarCategorias: () => {
        return http.get('api/forum/categories');
    },
    getCategoria: (id) => {
        return http.get('api/forum/categories/' + id);
    },
    saveCategoria: (data) => {
        return http.post('api/forum/categories', data);
    },
    updateCategoria: (id, data) => {
        return http.put('api/forum/categories/' + id, data);
    },
    deleteCategoria: (id) => {
        return http.delete('api/forum/categories/' + id);
    },
    uploadCategoryBanner: (id, formData) => {
        return http.post('api/forum/categories/' + id + '/banner', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    getCategoryBannerUrl: (id, filename) => {
        const baseURL = http.defaults.baseURL || '';
        return baseURL + 'api/forum/categories/' + id + '/banner/' + filename;
    },

    // ─── POSTS ──────────────────────────────────────────────────
    listarPosts: (params) => {
        return http.get('api/forum/posts', { params });
    },
    getPost: (id) => {
        return http.get('api/forum/posts/' + id);
    },
    savePost: (data) => {
        if (data instanceof FormData) {
            return http.post('api/forum/posts', data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        }
        return http.post('api/forum/posts', data);
    },
    updatePost: (id, data) => {
        return http.put('api/forum/posts/' + id, data);
    },
    deletePost: (id) => {
        return http.delete('api/forum/posts/' + id);
    },

    // ─── IMÁGENES DE POST ───────────────────────────────────────
    uploadSingleImage: (postId, formData) => {
        return http.post('api/forum/posts/' + postId + '/image', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    uploadImages: (postId, formData) => {
        return http.post('api/forum/posts/' + postId + '/images', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    deleteImage: (postId, imageId) => {
        return http.delete('api/forum/posts/' + postId + '/images/' + imageId);
    },
    updateImage: (postId, imageId, data) => {
        return http.put('api/forum/posts/' + postId + '/images/' + imageId, data);
    },
    getImageUrl: (postId, filename) => {
        const baseURL = http.defaults.baseURL || '';
        return baseURL + 'api/forum/posts/' + postId + '/image/' + filename;
    },

    // ─── BLOG SETTINGS ──────────────────────────────────────────
    getBlogSettings: () => {
        return http.get('api/forum/blog-settings');
    },
    updateBlogSettings: (data) => {
        return http.put('api/forum/blog-settings', data);
    },

    // ─── BLOG VISITS ────────────────────────────────────────────
    registrarBlogVisit: (data) => {
        return http.post('api/forum/blog-visit', data);
    },
    getBlogVisitCount: () => {
        return http.get('api/forum/blog-visit/count');
    },
    getBlogVisitMap: () => {
        return http.get('api/forum/blog-visit/map');
    },

    // ─── AUTORES ────────────────────────────────────────────────
    listarAdmins: () => {
        return http.get('api/forum/authors/admins');
    },
    getAuthorMe: () => {
        return http.get('api/forum/authors/me');
    },
    saveAuthor: (data) => {
        return http.post('api/forum/authors', data);
    },
    updateAuthor: (data) => {
        return http.put('api/forum/authors', data);
    },
    uploadAuthorImage: (formData) => {
        return http.post('api/forum/authors/image', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    assignAuthorCategories: (authorId, categoryIds) => {
        return http.put('api/forum/authors/' + authorId + '/categories', { category_ids: categoryIds });
    },
    getAuthorImageUrl: (authorId, filename) => {
        const baseURL = http.defaults.baseURL || '';
        return baseURL + 'api/forum/authors/' + authorId + '/image/' + filename;
    },

    // ─── COMENTARIOS ────────────────────────────────────────────
    listarComentarios: (postId) => {
        return http.get('api/forum/posts/' + postId + '/comments');
    },
    saveComentario: (postId, data) => {
        return http.post('api/forum/posts/' + postId + '/comments', data, { skipAuthInterceptor: true });
    },
    updateComentario: (id, data) => {
        return http.put('api/forum/comments/' + id, data);
    },
    deleteComentario: (id) => {
        return http.delete('api/forum/comments/' + id);
    },

    // ─── LIKES ──────────────────────────────────────────────────
    togglePostLike: (postId) => {
        return http.post('api/forum/posts/' + postId + '/like', {}, { skipAuthInterceptor: true });
    },
    likePostOnly: (postId) => {
        return http.post('api/forum/posts/' + postId + '/like-only', {}, { skipAuthInterceptor: true });
    },
    toggleCommentLike: (commentId) => {
        return http.post('api/forum/comments/' + commentId + '/like');
    },
    getLikesActivity: (params) => {
        return http.get('api/forum/admin/likes-activity', { params });
    },

    // ─── SUSCRIPCIONES ──────────────────────────────────────────
    subscribirCategoria: (data) => {
        return http.post('api/forum/subscriptions', data);
    },
    misSuscripciones: () => {
        return http.get('api/forum/subscriptions/me');
    },
    suscriptoresPorCategoria: (categoryId) => {
        return http.get('api/forum/subscriptions/category/' + categoryId);
    },
    notificarSuscriptores: (postId, data) => {
        return http.post('api/forum/subscriptions/notify/' + postId, data || {});
    }
};
